import Styles from './InstagramPostLoadingPreview.module.scss'
import { Skeleton } from 'antd'

export const InstagramPostLoadingPreview = () => {
  return (
    <div className={Styles.instagramPostLoadingPreview}>
      <div className={Styles.header}>
        <Skeleton avatar={{ size: 32 }} active paragraph={{ rows: 1, width: 150 }} title={false} />
      </div>
      <div className={Styles.body}></div>
      <div className={Styles.footer}>
        <Skeleton avatar={false} active paragraph={{ rows: 2, width: 391 }} title={false} />
      </div>
    </div>
  )
}
